import { render, staticRenderFns } from "./SelectServiceModal.vue?vue&type=template&id=25108940&"
import script from "./SelectServiceModal.vue?vue&type=script&lang=js&"
export * from "./SelectServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports